import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import notifications from "./stores/store.notifications";
import auth from "./stores/store.auth";
import payment from "./stores/store.payment";
import standAndDeliver from "./stores/store.stand_and_deliver";
import resource from "./stores/store.resource";
import journeys from "./stores/store.journeys";
import tags from "./stores/store.tags";
import community from "./stores/store.community";
import programLibrary from "./stores/store.programs";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    notifications,
    auth,
    payment,
    standAndDeliver,
    resource,
    journeys,
    tags,
    community,
    programLibrary,
  },
  state: {
    menuOpen: null,
    programs: null,
    selectedProgram: null,
    postTemplate: null,
    pageFixed: false,
    selectedTag: null,
    language: null,
    communityPlayingVideo: null,
    showWelcome: false,
  },
  mutations: {
    setSelectedProgram(state, program) {
      state.selectedProgram = program;
    },
    setPrograms(state, programs) {
      state.programs = programs;
    },
    setPageFixed(state, value) {
      state.pageFixed = value;
    },
    setCommunityTags(state, value) {
      state.communityTags = value;
    },
    setMenuOpen(state, menuName) {
      state.menuOpen = menuName;
    },
    setCommunityPlayingVideo(state, value) {
      state.communityPlayingVideo = value;
    },
    setSelectedTag(state, tag) {
      state.selectedTag = tag;
    },
    setShowWelcome(state, value) {
      state.showWelcome = value;
    }
  },
  getters: {
    programs(state) {
      return state.programs;
    },
    selectedProgram(state) {
      return state.selectedProgram;
    },
  },
  actions: {
    fixPage({ commit }) {
      commit("setPageFixed", true);
    },
    unfixPage({ commit }) {
      commit("setPageFixed", false);
    },
  },
});
